import React from "react";
import useSeo from "../hooks/useSeo";
import { Link } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const POSTS = [
  { title: "How to choose the right nanny for your family", date: "June 12, 2025", cat: "Guides",
    excerpt: "From first interview to trial day — a practical checklist to help you hire a nanny you can trust, with the questions that really matter." },
  { title: "Nanny, babysitter or au pair: what's the difference?", date: "May 28, 2025", cat: "Guides",
    excerpt: "The three are often confused. We break down the roles, typical hours and costs so you can pick the care that fits your family best." },
  { title: "What background checks really cover (and why they matter)", date: "May 9, 2025", cat: "Trust & safety",
    excerpt: "A look behind the scenes at how SimplySitter verifies identity, interviews caregivers and checks references before anyone can apply." },
  { title: "5 questions to ask before hiring a housekeeper", date: "April 21, 2025", cat: "Guides",
    excerpt: "Set clear expectations from day one. These five questions help you find a reliable housekeeper and avoid common misunderstandings." },
  { title: "Caregiver spotlight: tips from experienced nannies", date: "April 3, 2025", cat: "Stories",
    excerpt: "We asked top-rated caregivers on SimplySitter to share what makes a great family match. Their advice might surprise you." },
  { title: "Senior care at home: a gentle guide for families", date: "March 15, 2025", cat: "Guides",
    excerpt: "Compassionate companionship can transform daily life. Here's how to find the right senior caregiver for a loved one." },
];

export default function Blog() {
  useSeo("Childcare & Caregiving Tips Blog | SimplySitter", "Expert childcare, babysitting, housekeeping and senior care tips, hiring guides and family resources from the SimplySitter blog.");

  return (
    <div>
      <Header />
      <section className="hero-gradient">
        <div className="max-w-4xl mx-auto px-5 pt-16 pb-12 text-center">
          <h1 className="font-display text-[2.6rem] leading-[1.05] sm:text-6xl text-[#1f1a1b]">The SimplySitter Blog</h1>
          <p className="mt-5 text-[18px] leading-relaxed text-[#5a5254] max-w-2xl mx-auto">
            Guides, tips and stories to help families and caregivers navigate childcare and household help with confidence.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-5 py-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {POSTS.map((p) => (
              <article key={p.title} className="group rounded-2xl border border-black/[0.08] bg-white p-6 flex flex-col hover:border-[#7c2233]/30 hover:shadow-[0_18px_40px_-24px_rgba(124,34,51,0.35)] transition-all">
                <span className="inline-block w-fit text-[12px] font-medium text-[#7c2233] bg-[#f7e4e6] rounded-full px-2.5 py-0.5">{p.cat}</span>
                <h2 className="font-display text-xl text-[#1f1a1b] mt-3 leading-snug">{p.title}</h2>
                <p className="text-[15px] text-[#5a5254] mt-2 leading-relaxed flex-1">{p.excerpt}</p>
                <div className="flex items-center justify-between mt-5 pt-4 border-t border-black/[0.06]">
                  <span className="flex items-center gap-1.5 text-[13px] text-[#8a8285]"><Calendar className="w-3.5 h-3.5" />{p.date}</span>
                  <span className="inline-flex items-center gap-1 text-[14px] font-medium text-[#7c2233]">Read <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" /></span>
                </div>
              </article>
            ))}
          </div>
          <p className="text-center text-[14px] text-[#8a8285] mt-10">More articles coming soon.</p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
